import { type Common } from './common.js';
import { type CreateValues, type EncounterProblem } from './models/encounterProblem.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(encounterProblemId: string): Promise<EncounterProblem> {
    const url = this.common.constructPath(`/encounterProblem/${encounterProblemId}`);
    const { encounterProblem } = await this.common.getJSON(url);
    return encounterProblem;
  }

  async create(encounterProblem: CreateValues): Promise<EncounterProblem> {
    const url = this.common.constructPath('/encounterProblem/create');
    return await this.common.postJSON(url, encounterProblem);
  }
}
